// KPC 고객 웹에서 사용하는 작업코드와 화면 표기값을 한곳에서 관리한다.
export const KPC_WORK_TYPES = {
  GENERAL_INBOUND: "700131",
  SLX_PICKUP: "700112",
};

// KPC 여부를 문자열 대소문자와 무관하게 판별한다.
export const isKpcCompany = (company) => company?.toUpperCase() === "KPC";

// KPC 작업코드를 사용자 화면의 명칭으로 변환한다.
export const getKpcWorkTypeLabel = (tmDv) => {
  if (tmDv === KPC_WORK_TYPES.GENERAL_INBOUND) {
    return "일반입고 (700131)";
  }

  if (tmDv === KPC_WORK_TYPES.SLX_PICKUP) {
    return "SLX집하 (700112)";
  }

  return tmDv || "-";
};

// KPC 대시보드 응답을 기존 화면이 사용 중인 공통 필드로 변환한다.
export const normalizeKpcDashboardData = (data = {}) => ({
  total: Number(data.total) || 0,
  deliveryInTotal: Number(data.generalInboundTotal) || 0,
  deliveryOutTotal: Number(data.slxPickupTotal) || 0,
  vehicleCount: Number(data.vehicleCount) || 0,
  // 기존 화면의 차량 합계 칸에서도 KPC vehicleCount를 바로 표시한다.
  cntOfVehicle: Number(data.vehicleCount) || 0,
});

// KPC 주간·월간 통계 응답을 기존 차트의 count 배열 구조로 변환한다.
export const normalizeKpcChartData = (items = []) =>
  items.map((item) => ({
    scandate: item.scandate,
    count: [
      String(Number(item.generalInboundCount) || 0),
      String(Number(item.slxPickupCount) || 0),
    ],
  }));

// KPC 스캔 원장 항목은 표준 필드명(scanner_nm, camera_id)을 그대로 유지한다.
export const normalizeKpcScanItem = (item = {}) => ({
  ...item,
  // KPC 원장에는 기존 고객사와 달리 id가 없으므로 테이블 렌더링용 고유 키를 만든다.
  row_key:
    item.row_key ||
    [
      item.barcode || "",
      item.scandate || "",
      item.scantime || "",
      item.tm_dv || "",
      item.scanner_nm || "",
      item.camera_id || "",
    ].join("|"),
  barcode: item.barcode || "",
  scandate: item.scandate || "",
  scantime: item.scantime || "",
  tm_dv: item.tm_dv || "",
  scanner_nm: item.scanner_nm || "",
  camera_id: item.camera_id || "",
  send_status: item.send_status || "",
  result_no: item.result_no || "",
  result_msg: item.result_msg || "",
});

// KPC 월별 통계의 신규 필드를 기존 달력 컴포넌트 호환 필드로 보완한다.
export const normalizeKpcCalendarData = (months = []) =>
  months.map((month) => {
    const normalizeDay = (day) => ({
      ...day,
      deliveryInCount: Number(day.generalInboundCount) || 0,
      deliveryOutCount: Number(day.slxPickupCount) || 0,
    });

    return {
      ...month,
      days: Array.isArray(month.days) ? month.days.map(normalizeDay) : [],
      dayskey: Object.entries(month.dayskey || {}).reduce((result, [date, day]) => {
        result[date] = normalizeDay(day);
        return result;
      }, {}),
    };
  });
